import { CSSProperties } from 'aphrodite/no-important';

export const style: CSSProperties = {
  '-webkit-font-smoothing': 'antialiased',
  margin: 0,
};
